module.exports = "<p class=\"info info--ok\" translate>auth.resetPassword.success</p>\n<p class=\"info-text\" [routerLink]=\"['/login']\" [innerHTML]=\"'auth.resetPassword.successLink' | translate\"></p>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/auth/reset-password/reset-password-done/reset-password-done.component.html
// module id = ../../../../../src/app/auth/reset-password/reset-password-done/reset-password-done.component.html
// module chunks = main